const updateEmailsIsLoading = (state, action) => {
	const { isLoadingItems } = action.payload;
	return { ...state, isLoadingItems };
};

const updatePagination = (state, action) => {
	const { paginationData, paginationType } = action.payload;
	return {
		...state,
		pagination: { ...state.pagination, [paginationType]: paginationData },
	};
};

const updateEmails = (state, action) => {
	const { emailData } = action.payload;
	return { ...state, emails: emailData };
};

const updateActiveModal = (state, action) => {
	const { currentTab } = action.payload;
	return { ...state, activeEmailModalTab: currentTab };
};

const updateActiveEmailId = (state, action) => {
	const { emailId } = action.payload;
	return { ...state, activeEmailId: emailId };
};

const updateActiveEmailData = (state, action) => {
	const { activeEmailData } = action.payload;
	return { ...state, activeEmailData };
};

const updateEmailFilterDates = (state, action) => {
	const { dates } = action.payload;
	const { startDate, endDate } = dates;
	return {
		...state,
		filters: {
			...state.filters,
			dateRange: { ...state.filters.dateRange, startDate, endDate },
		},
	};
};

const updateEmailStatusFilter = (state, action) => {
	const { status } = action.payload;
	return { ...state, filters: { ...state.filters, emailStatus: status } };
};

const updateEmailPagination = (state, action) => {
	const { size, skip, totalItemCount } = action.payload;
	return {
		...state,
		pagination: {
			...state.pagination,
			emails: { ...state.pagination.emails, totalItemCount, skip, size },
		},
	};
};

const updateEmailToSearch = (state, action) => {
	const { emailAddress } = action.payload;
	return {
		...state,
		filters: { ...state.filters, emailToSearch: emailAddress },
	};
};

const updateEmailSearchToFromToggle = (state, action) => {
	const { searchEmailToOrFrom } = action.payload;
	return {
		...state,
		filters: { ...state.filters, emailSearchToFromToggle: searchEmailToOrFrom },
	};
};

const updateEmailContentPreviewType = (state, action) => {
	const { emailContentPreviewType } = action.payload;
	return { ...state, emailContentPreviewType };
};

const updateIsLoadingSingleEmailData = (state, action) => {
	const { isLoadingSingleEmailData } = action.payload;
	return { ...state, isLoadingSingleEmailData };
};

const updateSelectedEmails = (state, action) => {
	const { newSelectedEmails } = action.payload;
	return { ...state, selectedEmails: newSelectedEmails };
};

const updateEmailsSkip = (state, action) => {
	const { skip } = action.payload;
	return {
		...state,
		pagination: {
			...state.pagination,
			emails: { ...state.pagination.emails, skip },
		},
	};
};

const updateEmailsSize = (state, action) => {
	const { size } = action.payload;
	return {
		...state,
		pagination: {
			...state.pagination,
			emails: { ...state.pagination.emails, size },
		},
	};
};

const updateSortBy = (state, action) => {
	const { sortBy, sortDirection } = action.payload;
	return {
		...state,
		sorting: {
			...state.sorting,
			sortBy,
			sortDirection: sortDirection ? 'DESC' : 'ASC',
		},
	};
};

export const mainReducers = {
	UPDATE_EMAILS_IS_LOADING: updateEmailsIsLoading,
	EMAILS_UPDATE_PAGINATION: updatePagination,
	EMAILS_UPDATE_EMAILS: updateEmails,
	UPDATE_CURRENT_MODAL_TAB: updateActiveModal,
	UPDATE_ACTIVE_EMAIL_ID: updateActiveEmailId,
	UPDATE_ACTIVE_EMAIL_DATA: updateActiveEmailData,
	UPDATE_EMAIL_STATUS_FILTER: updateEmailStatusFilter,
	UPDATE_EMAIL_PAGINATION: updateEmailPagination,
	UPDATE_EMAIL_TO_SEARCH: updateEmailToSearch,
	EMAIL_SEARCH_TO_FROM_TOGGLE: updateEmailSearchToFromToggle,
	UPDATE_EMAIL_FILTER_DATES: updateEmailFilterDates,
	UPDATE_EMAIL_CONTENT_PREVIEW_TYPE: updateEmailContentPreviewType,
	UPDATE_IS_LOADING_SINGLE_EMAIL_DATA: updateIsLoadingSingleEmailData,
	EMAILS_UPDATE_SELECTED_EMAILS: updateSelectedEmails,
	EMAILS_UPDATE_EMAILS_SKIP: updateEmailsSkip,
	EMAILS_UPDATE_SORT_BY: updateSortBy,
	EMAILS_UPDATE_EMAILS_SIZE: updateEmailsSize,
};

export default mainReducers;
